import React, { useState, useCallback, useEffect } from 'react';
import { useRouter } from 'next/router';
import clsx from 'clsx';
import MobileOrDesktopDialog from '../mobileOrDesktopDialog';
// import { ISegmentEventData, trackAppEvents } from '@';
import { resolvePath } from 'Utils/resolvePath';
import { useWebviewCallback } from 'Utils/webviewHandlers';
import { DarkButton } from '@acko-tech/building-blocks.ui.button';
import { EWebViewActions } from 'Types/index';
import { PageRoutes } from '@/constants/trackingStages';
import BackArrow from 'Assets/Icons/left-arrow-v2.svg';
import HelpCall from 'Assets/Icons/help-call.svg';
import Help from '../help';
import * as Styles from './styles';
import { trackEventAPI } from '@/analytics/middleware';
import { TAP_HELP_CTA } from '@/analytics/events';
import Cookies from 'js-cookie';
import { useIsNativeAppbar } from '@/hooks/useAppBarUpdate';

interface IHeaderProps {
    margin?: string;
    backURL?: string;
    hideHelp?: boolean;
    hideLogo?: boolean;
    hideBack?: boolean;
    forceShowMobileVersion?: boolean;
    hideMobileHeader?: boolean;
    hideDesktopHeader?: boolean;
    // trackEventParams?: ISegmentEventData;
    isIST?: boolean;
    onBackClick?: () => void;
}

export default function Header(props: IHeaderProps) {
    const [show, setShow] = useState(false);
    const {
        hideHelp,
        margin,
        backURL,
        hideLogo,
        hideBack,
        // trackEventParams,
        forceShowMobileVersion,
        hideMobileHeader,
        hideDesktopHeader,
        isIST,
        onBackClick,
    } = props;
    const router = useRouter();
    const isWebView = Boolean(Cookies.get('webview'));
    const useCustomBack = () => {
        if (onBackClick) {
            onBackClick();
        } else if (backURL) {
            window.location.href = backURL;
        } else {
            router.back();
        }
    };

    const goBack = () => {
        try {
            useWebviewCallback(
                {
                    action: EWebViewActions.CAN_USE_NATIVE_BACK_PRESS,
                    action_value: {},
                },
                () => useCustomBack(),
                (res: any) => {
                    if (res === true) {
                        useWebviewCallback(
                            {
                                action: EWebViewActions.NATIVE_BACK_PRESS,
                                action_value: {},
                            },
                            () => useCustomBack()
                        );
                    } else useCustomBack();
                }
            );
        } catch (e) {
            window.location.replace(`${PageRoutes.REDIRECT}`);
        }
    };

    const refirectToHome = () => {
        window.location.href = '/';
    };

    const isNativeAppbar = useIsNativeAppbar();

    if (isNativeAppbar) {
        return null;
    }

    const showBack = !hideBack || forceShowMobileVersion;

    return (
        <Styles.Wrapper
            margin={margin}
            id="appHeader"
            hideMobileHeader={hideMobileHeader}
            hideDesktopHeader={hideDesktopHeader}
            className={clsx({ showMobView: forceShowMobileVersion })}
        >
            {!forceShowMobileVersion && !hideLogo && (
                <Styles.LogoWrapper id="headerLogo" onClick={refirectToHome}>
                    <Styles.Logo
                        src={resolvePath(
                            '/images/ad-logo-white-horizontal.svg'
                        )}
                    />
                </Styles.LogoWrapper>
            )}
            {showBack && (
                <Styles.IconWrapper id="headerBack" onClick={goBack}>
                    <BackArrow />
                </Styles.IconWrapper>
            )}
            {!hideHelp && (
                <Styles.HelpCTA
                    onClick={() => {
                        trackEventAPI({
                            event_name: TAP_HELP_CTA,
                            customAttributes: {},
                        });
                        setShow(true);
                    }}
                >
                    <HelpCall />
                    <span>Help</span>
                </Styles.HelpCTA>
            )}
            <Help show={show} onClose={setShow} />
        </Styles.Wrapper>
    );
}
